import {Component, Input, OnInit} from '@angular/core';

export enum NotificationType {
  information = 'information',
  alert = 'alert',
}

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent implements OnInit {
  @Input() notificationType: NotificationType = NotificationType.information;

  constructor() { }

  ngOnInit(): void {
  }
}
